import { xyz } from '@/Interfaces/common';

export const baskets = [
    {
        name: 'gbm_450_400_85',
        height: 0.085,
        width: 0.45,
        depth: 0.4,
        rotation: [ 0,0,180 ],
    },
    {
        name: 'gbm_450_400_185',
        height: 0.185,
        width: 0.45,
        depth: 0.4,
        rotation: [ 0,0,180 ],
    },
    {
        name: 'gbm_450_400_285',
        height: 0.385,
        width: 0.45,
        depth: 0.4,
        rotation: [ 0,0,180 ],
    },
    {
        name: 'gbm_600_400_85',
        height: 0.085,
        width: 0.6,
        depth: 0.4,
        rotation: [ 0,0,180 ],
    },
    {
        name: 'gbm_600_400_185',
        height: 0.185,
        width: 0.6,
        depth: 0.4,
        rotation: [ 0,0,180 ],
    },
    {
        name: 'gbm_600_400_285',
        height: 0.285,
        width: 0.6,
        depth: 0.4,
        rotation: [ 0,0,180 ],
    },

    {
        name: 'gbp_60_10',
        height: 0.1,
        width: 0.6,
        depth: 0.4,
    },
    {
        name: 'gbp_60_20',
        height: 0.2,
        width: 0.6,
        depth: 0.4,
    },
    {
        name: 'gbp_60_30',
        height: 0.3,
        width: 0.6,
        depth: 0.4,
        offsets: [ 0,-0.199,0 ],
    },
];

export const defaultBasketOffsets = [ 0,0.0005,0 ] as const;

export const defaultBasketRotation = [ 0,0,0 ] as const;
